import type { FeatureManifest } from '../registry.js';
import { HeartIcon } from './icon.js';

/**
 * SO-07 shop tour and likes (SCR-10 friend's shop): look inside a friend's shop, give it one
 * heart a day, and the popular-shops rank the hearts feed. Opened from a friend's street, the
 * friends screen and this rail entry. Needs friends, so it unlocks with them.
 */
export default {
  id: 'tour',
  flag: 'shopTour',
  unlock: 'friends',
  online: true,
  art: ['pip_extra'],
  provides: ['shopTour', 'popularShops'],
  entry: { order: 32, icon: HeartIcon, label: 'feature.tour.rail', testId: 'rail-tour', open: 'popularShops' },
  load: () => import('./index.js'),
} satisfies FeatureManifest;
